export const productTypeEnum = {
  DAILY: 0,
  TOTAL: 1,
};
